/**
 * External identifier → URL helpers.
 *
 * BUG-105: `openalex_id` values arrive in two shapes depending on the data
 * source — either a bare id like "A5023888391" / "W2741809807" or a full URL
 * like "https://openalex.org/A5023888391". Sites that blindly prefixed
 * `https://openalex.org/` produced doubled-up URLs for the URL shape, and the
 * site that used the raw value as an href 404'd (relative path) for the bare
 * shape. Every OpenAlex link in the app must go through this helper.
 */
export function openAlexUrl(id: string): string {
  return id.startsWith('http') ? id : `https://openalex.org/${id}`
}
